import { Outlet } from 'react-router-dom'
import { Flex, Stack } from '@chakra-ui/react'
import logo from '@/assets/TheLordHeritage_logo.png'

const LOGO_DIMENSION = 187

export default function AuthLayout() {
    return (
        <Flex minH={'100vh'} align={'center'} justify={'center'} bg={'gray.50'}>
            <Stack spacing={8} mx={'auto'} minW={['sm', 'md']} maxW={'lg'} py={12} px={6}>
                <Stack align={'center'}>
                    <img
                        src={logo}
                        alt="church logo"
                        width={LOGO_DIMENSION}
                        height={LOGO_DIMENSION}
                    />
                </Stack>

                <Outlet />
            </Stack>
        </Flex>
    )
}
